import { httpClient } from "@services/api/httpClient";

interface GetOfferParams {
  id: number
}

export async function getByOfferBuilderId({id }: GetOfferParams) {
  const response = await httpClient.get("/offer/get-by-offerBuilder-id", {
    params: { offerBuilderId: id }
  });
  return response.data;
}